<template>
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M5.99999 0.399902C6.33136 0.399902 6.59999 0.668532 6.59999 0.999902V5.3999H11C11.3314 5.3999 11.6 5.66853 11.6 5.9999C11.6 6.33127 11.3314 6.5999 11 6.5999H6.59999V10.9999C6.59999 11.3313 6.33136 11.5999 5.99999 11.5999C5.66862 11.5999 5.39999 11.3313 5.39999 10.9999V6.5999H0.999994C0.668623 6.5999 0.399994 6.33127 0.399994 5.9999C0.399994 5.66853 0.668623 5.3999 0.999994 5.3999H5.39999V0.999902C5.39999 0.668532 5.66862 0.399902 5.99999 0.399902Z"
    fill="currentColor" />
</template>
